import { RefObject, useLayoutEffect, useRef, useState } from "react";

export function useDimensions<TNode extends HTMLElement>(): [RefObject<TNode>, DOMRect | undefined] {
    const ref = useRef<TNode>(null);
    const [dimensions, setDimensions] = useState<DOMRect | undefined>();

    useLayoutEffect(() => {
        setDimensions(ref.current?.getBoundingClientRect()?.toJSON());
    }, []);

    return [ref, dimensions];
}
